import { ClientRoutesEnum } from "@utilities/enums";
import { fetchRequest } from "@utilities/requests";
import { Client } from "@utilities/types";

export const clientService = {
    createClient: async (clientData: Partial<Client>) => {
        return await fetchRequest({
            route: ClientRoutesEnum.CLIENT_CREATE,
            method: "POST",
            data: clientData,
        });
    },

    getAllClients: async (organisatinID: string) => {
        return await fetchRequest({
            route: `${ClientRoutesEnum.CLIENT_GET_ALL}/${organisatinID}`,
            method: "GET",
        });
    },

    findClient: async (search: string, organisatinID: string) => {
        return await fetchRequest({
            route: `${ClientRoutesEnum.CLIENT_FIND}?search=${search}&organisationID=${organisatinID}`,
            method: "GET",
        });
    },

    updateClient: async (clientId: string, clientData: Partial<Client>) => {
        return await fetchRequest({
            route: `${ClientRoutesEnum.CLIENT_UPDATE}/${clientId}`,
            method: "PUT",
            data: clientData,
        });
    },

    deleteClient: async (clientId: string) => {
        return await fetchRequest({
            route: `${ClientRoutesEnum.CLIENT_DELETE}/${clientId}`,
            method: "DELETE",
        });
    },
};
